import syCard from "./sy-card";

export default syCard;
